// export const getDaysInMonth = (month: number, year: number): Date[] =>
//   Array.from(
//     { length: new Date(year, month, 0).getDate() },
//     (_, i) => new Date(year, month - 1, i + 1)
//   );
//
// export const getWeeksInMonth = (year: number, month: number, startDayOfWeek: number = 1): number => {
//   const firstDayOfWeek = startDayOfWeek;
//   const firstOfMonth = new Date(year, month-1, 1);
//   const lastOfMonth = new Date(year, month, 0);
//   const numberOfDaysInMonth = lastOfMonth.getDate();
//   const firstWeekDay = (firstOfMonth.getDay() - firstDayOfWeek + 7) % 7;
//   const used = firstWeekDay + numberOfDaysInMonth;
//   return Math.ceil( used / 7);
// }

export const formatDate = (date: Date, inUsOrder: boolean = true, isWithTime: boolean = false): string => {
  let timeString = ''
  if (isWithTime) {
    timeString = ` ${('0' + date.getHours()).slice(-2)}:${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}`
  }
  if (inUsOrder) {
    return date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2) + timeString
  }
  return ('0' + date.getDate()).slice(-2) + '.' + ('0' + (date.getMonth() + 1)).slice(-2) + '.' + date.getFullYear() + timeString
}

export const wait = async (timeMs = 100) => {
  return new Promise(resolve => setTimeout(resolve, timeMs))
}
